import {lazy} from './lazy.js';

export const slow = (densityFactor) => {
    return (coords, ...args) => {
        let _coords = {};
        let _densityFactor = lazy(densityFactor, ...args);
        for (let id in coords) {
            _coords[id] = {
                ... coords[id],
                density: _densityFactor * (coords[id].density || 1)
            };
        }
        return _coords;
    };
};

export const clear = () => {
    return (coords, ...args) => { return {}; };
}
